import { useNavigate } from "react-router-dom";
import { useCallback } from "react";
import { playerToString } from "../../util/StringUtils";
import type { Player } from "../../types/domain";

interface PodiumProps {
  players: Player[];
}

type PodiumPosition = "first" | "second" | "third";

interface PodiumPlayerProps {
  player: Player;
  position: PodiumPosition;
  medalSrc: string;
  heightClass: string;
}

function Podium({ players }: PodiumProps) {
  const navigate = useNavigate();
  const handleOnClick = useCallback((id: number) => navigate('/players/' + id), [navigate]);

  if (!players || players.length < 3) {
    return null;
  }

  const [first, second, third] = players;

  const PodiumPlayer = ({ player, position, medalSrc, heightClass }: PodiumPlayerProps) => (
    <div
      className={`podium-player podium-${position}`}
      onClick={() => handleOnClick(player.id)}
    >
      <div className="podium-info">
        <img src={medalSrc} alt={`${position} place`} className="podium-medal" />
        <div className="podium-name">{playerToString(player, false, true)}</div>
        <div className="podium-elo">{player.elo} ELO</div>
      </div>
      <div className={`podium-stand ${heightClass}`}>
        <span className="podium-position">{position === 'first' ? '1' : position === 'second' ? '2' : '3'}</span>
      </div>
    </div>
  );

  return (
    <div className="podium-container">
      <PodiumPlayer
        player={second}
        position="second"
        medalSrc="/icons/silver-medal.png"
        heightClass="podium-stand-2"
      />
      <PodiumPlayer
        player={first}
        position="first"
        medalSrc="/icons/gold-medal.png"
        heightClass="podium-stand-1"
      />
      <PodiumPlayer
        player={third}
        position="third"
        medalSrc="/icons/bronze-medal.png"
        heightClass="podium-stand-3"
      />
    </div>
  );
}

export default Podium;
